export default {
  name: "Dos Equis",
  favicon: `${process.env.REACT_APP_AZURE_STORAGE}/dosequis/logo.webp`,
  logo: `${process.env.REACT_APP_AZURE_STORAGE}/dosequis/logo.webp`,
  logoColor: `${process.env.REACT_APP_AZURE_STORAGE}/dosequis/logo-color.webp`,
  products: [
    {
      id: "dosequis",
      image: {
        en: `${process.env.REACT_APP_AZURE_STORAGE}/dosequis/en/product_forward_dosequis.webp`,
        fr: `${process.env.REACT_APP_AZURE_STORAGE}/dosequis/fr/product_forward_dosequis.webp`,
      },
      name: {
        en: "Lager",
        fr: "Lager",
      },
      description: {
        en: "Dos Equis® Lager Especial is a golden pilsner-style beer made from spring water and the choicest hops. With a balanced composition and a smooth, clean finish, it’s the party guest who is always invited and never overstays his welcome.",
        fr: "La bière Dos Equis® Lager Especial est une bière dorée de style pilsner, fabriquée à partir d'eau de source et des meilleurs houblons. Bien équilibrée en bouche, elle offre une finale tout en douceur. C'est l'invitée de toutes les fêtes, toujours la bienvenue et jamais de trop.",
      },
      formats: [
        {
          image: {
            en: `${process.env.REACT_APP_AZURE_STORAGE}/dosequis/en/information_render_bottle_355ml_dosequis.webp`,
            fr: `${process.env.REACT_APP_AZURE_STORAGE}/dosequis/fr/information_render_bottle_355ml_dosequis.webp`,
          },
          details: {
            en: `${process.env.REACT_APP_AZURE_STORAGE}/dosequis/en/information_nft_bottle_355ml_dosequis.webp`,
            fr: `${process.env.REACT_APP_AZURE_STORAGE}/dosequis/fr/information_nft_bottle_355ml_dosequis_fr.webp`,
          },
          name: {
            en: "Bottle 355ml",
            fr: "Bouteille 355ml",
          },
        },
      ],
    },
  ],
};
